import React from 'react';

// Components

import UniversalInput from '../../../../../lib/wrappers/UniversalInput';

// Utils

import { getHhmByPersonId } from '../../../../../utils/normalize/getHhmByPersonId';

// Constants

import { DROPDOWN_OPTIONS } from '../../../../../constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '../../../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../../../constants/inputs/validationTypes';



const AnotherParentQuestionBlock = props => {

    const {
        listOfClaimedBySeparatelyLivingParent,
        householdMembers,
        onFieldChange,
        ...restProps
    } = props;

    return listOfClaimedBySeparatelyLivingParent.length !== 0
        ? (
            <div className = 'subsection' >
                {
                    listOfClaimedBySeparatelyLivingParent.map(d => {

                        const {
                            dependentFullName,
                            dependentPersonId
                        } = d;

                        const hhm = getHhmByPersonId(dependentPersonId, householdMembers);

                        const {
                            taxHouseholdComposition: {
                                livesSeparatelyFromClaimerParent
                            }
                        } = hhm;

                        const value = livesSeparatelyFromClaimerParent === true
                            ? false
                            : livesSeparatelyFromClaimerParent === false
                                ? true
                                : null;

                        return (
                            <UniversalInput
                                key = { `${ dependentPersonId }_${ dependentFullName }` }
                                legend = { {
                                    legendText: 'ssap.input.legend.does_dependent_lives_with_parents',
                                    legendTextReplacements: {
                                        dependentFullName: <strong>{ dependentFullName }</strong>
                                    }
                                } }
                                label = { {
                                    labelClass: [ 'usa-width-one-whole', 'layout--02' ],
                                    ulClass: [ 'usa-width-one-whole margin-b-20' ],
                                    showRequiredIcon: true
                                } }
                                inputData = { {
                                    isInputRequired: true,
                                    type: INPUT_TYPES.RADIO_BUTTONS,
                                    classes: [ 'disp-styl-none' ],
                                    name: 'livesSeparatelyFromClaimerParent',
                                    value: value,
                                    options: DROPDOWN_OPTIONS.YES_NO,
                                    validationType: VALIDATION_TYPES.CHOSEN,
                                    currentData: hhm,
                                    fields: [ 'taxHouseholdComposition' ]
                                } }
                                inputActions = { {
                                    onFieldChange
                                } }
                                indexInArray = { dependentPersonId - 1 }
                                { ...restProps }
                            />
                        );
                    })
                }
            </div>
        )
        : null;
};

export default AnotherParentQuestionBlock;
